import { Service } from "../settings";

export enum PersonalInternetServiceProfile {
  Household = "household",
  PerDevice = "perdevice",
}

export enum SubscriberSafetyServiceProfile {
  Standard = "standard",
  SBSingle = "sb-single",
  SBMultiple = "sb-multiple",
}

export enum SecureBusinessServiceProfile {
  Single = "single-profile",
  Multiple = "multiple-profile",
}

interface PersonalInternetActivationCommand {
  service: Service.PersonalInternet;
  serviceProfile: PersonalInternetServiceProfile;
}

interface SubscriberSafetyActivationCommand {
  service: Service.SubscriberSafety;
  serviceProfile?: SubscriberSafetyServiceProfile;
  enabled?: boolean;
}

interface SecureBusinessActivationCommand {
  service: Service.SecureBusiness;
  serviceProfile: SecureBusinessServiceProfile;
}

export type ServicesActivationCommand = (
  | PersonalInternetActivationCommand
  | SubscriberSafetyActivationCommand
  | SecureBusinessActivationCommand
)[];
